export default __webpack_public_path__ + "static/media/030-eggplant.b3f3e567.svg";